export default __webpack_public_path__ + "static/media/default_map (Traced).26a3fda1.svg";